module.exports = __webpack_public_path__ + "static/Fantastic_Beasts_1920x900-mobile.1cb2b175.png";